import { Payload, UseCase } from '@smile-next/uikit';
import { NextAccountLoginPageStateProps } from '@/containers/NextAccountLogin/Page/NextAccountLoginPageState';
import { authParamsRepository, AuthParamsRepository } from '@/infra/repository/AuthParamsRepository';
import { AuthParamsConverter } from '@/models/domain/AuthParams';
import { LoginId } from '@/models/domain/LoginId';
import { Password } from '@/models/domain/Password';

export class InitializedNextAccountLoginFormPayload extends Payload {
    type = 'InitializedNextAccountLoginFormPayload';
    constructor(public readonly initializeNextAccountPageStateProps: NextAccountLoginPageStateProps) {
        super();
    }
}

type InitializeNextAccountLoginFormUsecaseArgs = {
    authParamsRepository?: AuthParamsRepository;
};

type InitializeNextAccountLoginFormProps = {
    cloudId?: string;
    loginId?: string;
};

export class InitializeNextAccountLoginFormUseCase extends UseCase {
    private infra: Required<InitializeNextAccountLoginFormUsecaseArgs>;
    constructor(args: InitializeNextAccountLoginFormUsecaseArgs = {}) {
        super();
        this.infra = {
            authParamsRepository,
            ...args,
        };
    }

    execute(nextAccountLoginFormProps: InitializeNextAccountLoginFormProps) {
        const { cloudId, loginId } = nextAccountLoginFormProps;
        const inputAuthParams = AuthParamsConverter.fromJSON({ cloudId });
        const savedAuthParams = this.infra.authParamsRepository.get();
        const authParams = savedAuthParams.join(inputAuthParams);

        this.dispatch(
            new InitializedNextAccountLoginFormPayload({
                authParams,
                loginId: new LoginId({ value: loginId || '' }),
                password: new Password({ value: '' }),
            }),
        );
    }
}
